import {UserStateModel} from './user.model';

export class Save {
  static readonly type = '[User] save';

  constructor(public params: UserStateModel) {
  }
}
